<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CButton @click="collapse=!collapse" color="primary" class="mb-2">
                    فیلتر داده‌ها
                </CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>گزینه‌های فیلتر</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.title.val" :description="form.title.inv" label="عنوان" />
                                </CCol>
                                <CCol sm="3">
                                    <label>تاریخ آپلود</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.created_at.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.created_at.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>آخرین به‌روزرسانی</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.updated_at.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.updated_at.inv}}</small>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.file_type.val"
                                        :description="form.file_type.inv"
                                        label="نوع فایل"
                                        :options="[
                                            {value: '', label: 'هیچ‌کدام'},
                                            {value: '1', label: 'تعهدنامه'},
                                            {value: '2', label: 'درخواست خطوط خدماتی'},
                                            {value: '3', label: 'مدارک شناسایی'},
                                            {value: '4', label: 'سایر موارد'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.file_type.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.state.val"
                                        :description="form.state.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: '', label: 'هیچ‌کدام'},
                                            {value: '0', label:'بررسی نشده'},
                                            {value: '1', label:'تایید شده'},
                                            {value: '2', label:'رد شده'},
                                            {value: '4', label:'بررسی شده'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.state.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();filter=true;page=1;get();" class="ml" color="primary">فیلتر</CButton>
                                <CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>اسناد و مدارک</strong>
                        <div class="card-header-actions">
                            تعداد: {{row_count}}
                        </div>
                        </CCardHeader>
                    <CCardBody>
                        <CCol sm="5">
                            <CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
                                {value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count" placeholder="تعداد سطرها" @change="limit=$event.target.value" />
                        </CCol>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                            <template #user_name="data">
                                <td>
                                    <router-link :to="`/profile/${data.item.user_id}`">{{data.item.user_name}}</router-link>
                                </td>
                            </template>
                            <template #state="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.state)">
                                        {{data.item.state}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #file_type="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.file_type)">
                                        {{data.item.file_type}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #short_admin_message="data">
                                <td v-if="data.item.short_admin_message.length <= 20">{{data.item.short_admin_message}}</td>
                                <td v-else>
                                    <CButton @click="message_modal=true;message=data.item.full_admin_message"
                                    color="link">{{data.item.short_admin_message}}</CButton> 
                                </td>
                            </template>
                            <template #action="data">
                                <td v-if="data.item.can_delete
                                    || data.item.can_download
                                    || data.item.can_accept">
                                <template>
                                    <div class="flex-container">
                                        <div v-show="data.item.state == 'بررسی نشده'">
                                            <div v-show="data.item.can_accept"
                                                @click="redirect_to(`file/${data.item.id}/status`)"
                                                v-c-tooltip.hover="'تعیین وضعیت'">
                                                <CIcon name="cilCheck" size="lg"/>
                                            </div>
                                        </div>
                                        <div v-show="data.item.can_download"
                                            @click="download_modal=true;id=data.item.id"
                                            v-c-tooltip.hover="'دانلود فایل'">
                                            <CIcon name="cilCloudDownload" size="lg"/>
                                        </div>
                                        <div v-show="data.item.can_delete"
                                            @click="delete_modal=true;id=data.item.id"
                                            v-c-tooltip.hover="'حذف'">
                                            <CIcon name="cilTrash" size="lg"/>
                                        </div>
                                    </div>
                                </template>
                                </td>
                                <td v-else>---</td>
                            </template>
                        </CDataTable>
                            <br>
                            <div> 
                                <CPagination
                                :activePage.sync="page"
                                :pages="page_count"
                                align="center"
                                :doubleArrows="true"
                                />
                            </div>
                        </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            title="دقت کنید"
            size="sm"
            color="danger"
            :show.sync="delete_modal"
            >
            <p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
            <template #footer>
                <CButton @click="delete_modal=false" color="secondary">خیر</CButton>
                <CButton @click="delete_row" color="danger">بله</CButton>
            </template>
        </CModal>
        <CModal
            title="دقت کنید"
            size="sm"
            color="primary"
            :show.sync="download_modal"
            >
            <p>آیا برای دانلود فایل اطمینان دارید؟</p>
            <template #footer>
                <CButton @click="download_modal=false" color="secondary">خیر</CButton>
            <CButton @click="download" color="primary">بله</CButton>
            </template>
        </CModal>
        <CModal
            title="متن کامل توضیحات"
            size="sm"
            color="primary"
            :show.sync="message_modal"
            >
            <p v-html="message"></p>
            <template #footer>
                <CButton @click="message_modal=false" color="primary">بستن</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data () {
        return {
            row_count: '',
            items: [],
            fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'user_name', label: 'کاربر' },
                { key: 'title', label: 'عنوان' },
                { key: 'created_at', label: 'تاریخ آپلود' },
                { key: 'state', label: 'وضعیت' },
                { key: 'file_type', label: 'نوع فایل' },
                { key: 'updated_at', label: 'آخرین به‌روزرسانی' },
                { key: 'short_admin_message', label: 'توضیحات' },
                { key: 'action', label: 'عملیات' },
            ],
            collapse: false,
            form: {
                user_id: { val: '', inv: '', v: { max: 8 } },
                title: { val: '', inv: '', v: { max: 256 } },
                created_at: { val: '', inv: '', v: { max: 16 } },
                updated_at: { val: '', inv: '', v: { max: 16 } },
                file_type: { val: '', inv: '', v: { max: 4 } },
                state: { val: '', inv: '', v: { max: 4 } },
            },
            filter: false,
            disable: false,
            page: 1,
            page_count: 0,
            offset: 0,
            limit: 10,
            users: [],
            delete_modal: false,
            download_modal: false,
            message_modal: false,
            message: '',
            id: 0,
        }
    },
    watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        }
    },
    mounted(){
        this.get();
        this.get_users();
    },
    methods: {
        get_users(){
            this.axios.get('users/?type=view_files')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
        get_badge(status) {
            switch(status) {
                case 'بررسی شده': return 'info';
                case 'تایید شده': return 'success';
                case 'بررسی نشده': return 'warning';
                case 'رد شده': return 'danger';
                default: return 'secondary';
            }
        },
        get() {
            if (this.disable == false) {
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            if (key == 'created_at' || key == 'updated_at') {
                                filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                            } else {
                                filter += `&${key}=` + this.form[key].val;
                            }
                        }
                    }
                }
                this.axios.get('user_files/' 
                    + '?count=1' 
                    + filter)
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
                        this.offset = 0;
                        if(this.page != 1){
                            this.offset = (this.page * this.limit) - this.limit;
                        }
                    })
                .finally(() => {
                    this.axios.get('user_files/' 
                        + '?limit=' + this.limit 
                        + '&offset=' + this.offset 
                        + '&user_info=1' 
                        + filter)
                        .then(res => {
                            res.data.map(val => {
                                val.user_name = `${val.user_info.first_name} ${val.user_info.last_name}`;
                                if(val.updated_at == '0001-01-01T00:00:00Z'){
                                    val.updated_at = '---';
                                } else {
                                    val.updated_at = this.$moment(val.updated_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                                }
                                val.created_at = this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                                switch(val.file_type){
                                    case 1:
                                        val.file_type = 'تعهدنامه';
                                        break;
                                    case 2:
                                        val.file_type = 'درخواست خطوط خدماتی';
                                        break;
                                    case 3:
                                        val.file_type = 'مدارک شناسایی';
                                        break;
                                    case 4:
                                        val.file_type = 'سایر موارد';
                                        break;
                                }
                                switch(val.state){
                                    case 0:
                                        val.state = 'بررسی نشده';
                                        break;
                                    case 1:
                                        val.state = 'تایید شده';
                                        break;
                                    case 2:
                                        val.state = 'رد شده';
                                        break;
                                    case 4:
                                        val.state = 'بررسی شده';
                                        break;
                                }
                                if(val.admin_message == ''){
                                    val.short_admin_message = '---';
                                } else {
                                    if(val.admin_message.length > 20){
                                        val.full_admin_message = val.admin_message;
                                        val.short_admin_message = val.full_admin_message.substring(0, 20);
                                        val.short_admin_message += '...';
                                    } else {
                                        val.short_admin_message = val.admin_message;
                                    } 
                                }
                            });
                            this.items = res.data;
                        })
                })
            }
        },
        remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
        delete_row() {
			this.axios.delete('user_files/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
                });
				this.delete_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
                });
                this.delete_modal = false;
			})
        },
        download(){
            this.$notify({
                group: 'foo',
                type: 'success',
                text: 'فایل در حال دانلود است. لطفا صبور باشید.'
            });
            this.download_modal = false;
            this.axios.get('user_files_attachment/?id='
                + this.id, {responseType: 'blob'})
                .then(res => {
                    const FileSaver = require('file-saver');
                    FileSaver.saveAs(new Blob([res.data], {type : res.headers['content-type']}));
                })
                .catch(() => {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        text: 'خطا! لطفا مجددا تلاش کنید.'
                    });
                    this.download_modal = false;
                })
        },
        redirect_to(route) {
            this.$router.push(route);
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_user_files_page == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
